import { createBrowserRouter, Navigate } from "react-router-dom";

import { AppShell } from "@/components/layout/app-shell";
import { ProtectedRoute } from "@/components/protected-route";
import { RoleHome } from "@/components/role-home";
import { ActivityPage } from "@/pages/activity";
import { AnnouncePage } from "@/pages/announce";
import { BroadcastDetailPage } from "@/pages/broadcast-detail";
import { CalendarPage } from "@/pages/calendar";
import { CategoriesPage } from "@/pages/categories";
import { CategoryDetailPage } from "@/pages/category-detail";
import { ChangelogPage } from "@/pages/changelog";
import { CidadesPage } from "@/pages/cidades";
import { ClientDetailPage } from "@/pages/client-detail";
import { ClientsPage } from "@/pages/clients";
import { ClosingReviewPublicPage } from "@/pages/closing-review-public";
import { ClosingsPage } from "@/pages/closings";
import { ContractDetailPage } from "@/pages/contract-detail";
import { ContractsPage } from "@/pages/contracts";
import { DeliveryPage } from "@/pages/delivery";
import { DispatchPage } from "@/pages/dispatch";
import { ErrorPage } from "@/pages/error-page";
import { IntegrationsPage } from "@/pages/integrations";
import { McpSetupPage } from "@/pages/mcp-setup";
import { InvoiceDetailPage } from "@/pages/invoice-detail";
import { InvoicesPage } from "@/pages/invoices";
import { JobDetailPage } from "@/pages/job-detail";
import { JobsPage } from "@/pages/jobs";
import { LoginPage } from "@/pages/login";
import { NerdDetailPage } from "@/pages/nerd-detail";
import { NerdsPage } from "@/pages/nerds";
import { NfSubmitPublicPage } from "@/pages/nf-submit-public";
import { PaymentWindowsPage } from "@/pages/payment-windows";
import { PortalPage } from "@/pages/portal";
import { ProfilePage } from "@/pages/profile";
import { ReportsPage } from "@/pages/reports";
import { SettingsPage } from "@/pages/settings";
import { SetupPage } from "@/pages/setup";
import { UsersPage } from "@/pages/users";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  // Páginas PÚBLICAS (magic-link, sem login nem AppShell)
  { path: "/fechamento/:token", element: <ClosingReviewPublicPage /> },
  { path: "/nf/:token", element: <NfSubmitPublicPage /> },
  {
    path: "/setup",
    element: <ProtectedRoute requireOnboarded={false} />,
    children: [{ index: true, element: <SetupPage /> }],
  },
  {
    path: "/",
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <RoleHome /> },

          // Portal logado (cliente/técnico)
          { path: "portal", element: <PortalPage /> },

          // Operação
          { path: "jobs", element: <JobsPage /> },
          { path: "jobs/:id", element: <JobDetailPage /> },
          { path: "calendar", element: <CalendarPage /> },
          { path: "dispatch", element: <DispatchPage /> },
          { path: "dispatch/:id", element: <BroadcastDetailPage /> },

          // Cadastros
          { path: "clients", element: <ClientsPage /> },
          { path: "clients/:id", element: <ClientDetailPage /> },
          { path: "nerds", element: <NerdsPage /> },
          { path: "nerds/:id", element: <NerdDetailPage /> },
          { path: "contracts", element: <ContractsPage /> },
          { path: "contracts/:id", element: <ContractDetailPage /> },
          { path: "categories", element: <CategoriesPage /> },
          { path: "categories/:id", element: <CategoryDetailPage /> },
          { path: "cidades", element: <CidadesPage /> },

          // Financeiro
          { path: "invoices", element: <InvoicesPage /> },
          { path: "invoices/:id", element: <InvoiceDetailPage /> },
          { path: "closings", element: <ClosingsPage /> },
          { path: "payment-windows", element: <PaymentWindowsPage /> },

          // Análise
          { path: "reports", element: <ReportsPage /> },
          { path: "activity", element: <ActivityPage /> },

          // Admin
          { path: "users", element: <UsersPage /> },
          { path: "integrations", element: <IntegrationsPage /> },
          { path: "changelog", element: <ChangelogPage /> },
          { path: "delivery", element: <DeliveryPage /> },
          { path: "mcp", element: <McpSetupPage /> },
          { path: "announce", element: <AnnouncePage /> },

          // Pessoal
          { path: "profile", element: <ProfilePage /> },
          { path: "settings", element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
